export default "__VITE_ASSET__C7jdeu2q__"